import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { TaskDtoKeysEnum } from '@zaoblako/shared/modules/task/enum/task-dto-keys.enum';
import { TaskOrder1cStatusEnum } from '@zaoblako/shared/modules/task/enum/task.order.1c.status.enum';

import * as yup from 'yup';

export interface TaskOrderFindInterface {
  /** Unique identifier. Cannot be changed */
  id: number;
  /** Order creation date and time */
  created: Date;
  /** Order last update date and time */
  updated: Date;
  /** Payment amount in roubles */
  amount: number;
  /** Task order subject */
  subject: string;
  /** Payment date */
  date: Date;
  /** Document code in 1C ERP database */
  document: string;
  /** Deletion mark from 1C ERP database */
  deleted: boolean;
  /** Payment order status in 1C ERP database */
  status: TaskOrder1cStatusEnum;
}

export const TaskOrderFindDto = SerdeDtoClass.create<TaskOrderFindInterface>(TaskDtoKeysEnum.TASK_ORDER_FIND_DTO, {
  id: {
    label: 'Номер',
    serializer: yup.number(),
  },
  created: {
    label: 'Создано',
    serializer: yup.date(),
  },
  updated: {
    label: 'Обновлено',
    serializer: yup.date(),
  },
  amount: {
    label: 'Сумма платежа',
    serializer: yup.number(),
  },
  subject: {
    label: 'Назначение платежа',
    serializer: yup.string(),
  },
  date: {
    label: 'Дата платежа',
    serializer: yup.date(),
  },
  document: {
    label: 'Номер платежа в 1С',
    hint: 'Задан только для платежных поручений, выгруженных в 1С',
    serializer: yup.string(),
  },
  deleted: {
    label: 'Удалён',
    serializer: yup.boolean(),
  },
  status: {
    label: 'Статус в 1С',
    hint: 'Задан только для платежных поручений, выгруженных в 1С',
    serializer: yup
      .string()
      .oneOf(Object.values(TaskOrder1cStatusEnum)),
  },
});
